const DEFAULT_API_TOKEN =
  process.env.REACT_APP_TOKEN_EXTRATOR_FISCAL ||
  '';

const PORTALS = {
  nfe: { id: 'nfe', label: 'NF-e (SEFAZ)', baseUrl: 'https://www.nfe.fazenda.gov.br/portal', targetUrl: 'https://www.nfe.fazenda.gov.br/portal/listaConteudo.aspx?tipoConteudo=04BIflQt1aY=', hasDatabase: true, hasStatus: true },
  cte: { id: 'cte', label: 'CT-e (SEFAZ)', baseUrl: 'https://www.cte.fazenda.gov.br/portal', targetUrl: 'https://www.cte.fazenda.gov.br/portal/listaConteudo.aspx?tipoConteudo=Y0nErnoZpsg=', hasDatabase: true, hasStatus: true },
  nfe_svrs: { id: 'nfe_svrs', label: 'NF-e (Documentos - SVRS)', baseUrl: 'https://dfe-portal.svrs.rs.gov.br', targetUrl: 'https://dfe-portal.svrs.rs.gov.br/Nfe/Documentos', hasDatabase: true, hasStatus: true },
  cte_svrs: { id: 'cte_svrs', label: 'CT-e (Documentos - SVRS)', baseUrl: 'https://dfe-portal.svrs.rs.gov.br', targetUrl: 'https://dfe-portal.svrs.rs.gov.br/Cte/Documentos', hasDatabase: true, hasStatus: true },
  mdfe: { id: 'mdfe', label: 'MDF-e (Documentos - SVRS)', baseUrl: 'https://dfe-portal.svrs.rs.gov.br', targetUrl: 'https://dfe-portal.svrs.rs.gov.br/mdfe/Documentos', hasDatabase: true, hasStatus: true },
  nfce: { id: 'nfce', label: 'NFC-e (Documentos - SVRS)', baseUrl: 'https://dfe-portal.svrs.rs.gov.br', targetUrl: 'https://dfe-portal.svrs.rs.gov.br/Nfce/Documentos', hasDatabase: true, hasStatus: true },
  bpe: { id: 'bpe', label: 'BP-e (Documentos - SVRS)', baseUrl: 'https://dfe-portal.svrs.rs.gov.br', targetUrl: 'https://dfe-portal.svrs.rs.gov.br/Bpe/Documentos' },
  nf3e: { id: 'nf3e', label: 'NF3-e (Documentos - SVRS)', baseUrl: 'https://dfe-portal.svrs.rs.gov.br', targetUrl: 'https://dfe-portal.svrs.rs.gov.br/Nf3e/Documentos' },
  nfag: { id: 'nfag', label: 'NFAG (Documentos - SVRS)', baseUrl: 'https://dfe-portal.svrs.rs.gov.br', targetUrl: 'https://dfe-portal.svrs.rs.gov.br/Nfag/Documentos' },
  nfcom: { id: 'nfcom', label: 'NFCom (Documentos - SVRS)', baseUrl: 'https://dfe-portal.svrs.rs.gov.br', targetUrl: 'https://dfe-portal.svrs.rs.gov.br/Nfcom/Documentos' },
  nff: { id: 'nff', label: 'NFF (Documentos - SVRS)', baseUrl: 'https://dfe-portal.svrs.rs.gov.br', targetUrl: 'https://dfe-portal.svrs.rs.gov.br/Nff/Documentos' }
};

const CACHE_PREFIX = 'extrator_cache_';
const CACHE_TTL_RESULTS = 2 * 60 * 60 * 1000;
const CACHE_TTL_NOTIFICATIONS = 60 * 60 * 1000;

const getCache = (key) => {
  try {
    const item = sessionStorage.getItem(CACHE_PREFIX + key);
    if (!item) return null;
    const parsed = JSON.parse(item);
    if (Date.now() > parsed.expiry) {
      sessionStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
};

const setCache = (key, data, ttl) => {
  try {
    sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify({
      data,
      expiry: Date.now() + ttl
    }));
  } catch (error) {
    console.error('Falha ao salvar no sessionStorage', error);
  }
};

export {
  CACHE_TTL_NOTIFICATIONS,
  CACHE_TTL_RESULTS,
  DEFAULT_API_TOKEN,
  PORTALS,
  getCache,
  setCache
};
